module.exports = __webpack_public_path__ + "img/LS20130822_greenfire_013.a7287c96.jpg";